import React from 'react';
import { TouchableOpacity, View, Text, ImageBackground } from 'react-native';
import { adminStyles } from '../styles/adminStyles';

export const UniqueVenueCard = ({ 
  venue, 
  isAdmin = false, 
  onPhotoDelete, 
  onPhotoUpload 
}) => {
  const handleClick = () => {
    const url = `/venue/${venue.id}`;
    if (window.location.pathname !== url) {
      window.location.href = url;
    }
  };

  return (
    <TouchableOpacity 
      style={adminStyles.venueCard}
      onPress={handleClick}
    >
      <ImageBackground
        source={{ uri: venue.photos?.[0]?.url || require('../../assets/backgrounds/background.jpg') }}
        style={adminStyles.venueCardBackground}
        imageStyle={adminStyles.venueCardBackgroundImage}
      >
        <View style={adminStyles.venueCardContent}>
          <Text style={adminStyles.venueName}>{venue.name}</Text>
          <Text style={adminStyles.venueLocation}>{venue.city}, {venue.state}</Text>
          {isAdmin && (
            <>
              <Text style={adminStyles.venuePhotoCount}>
                Photos: {venue.photos?.length || 0}
              </Text>
              {venue.notFoundOnLiveNation && (
                <Text style={[adminStyles.venuePhotoCount, { color: 'rgba(231, 76, 60, 0.8)' }]}>
                  Not found on LiveNation
                  {venue.notFoundTimestamp && ` (${new Date(venue.notFoundTimestamp).toLocaleDateString()})`}
                </Text>
              )}
            </>
          )}
          
          {isAdmin && (
            <View style={adminStyles.venueActions}>
              {venue.photos?.length > 0 && (
                <TouchableOpacity
                  style={adminStyles.deleteButton}
                  onPress={(e) => {
                    e.stopPropagation();
                    onPhotoDelete(venue.id);
                  }}
                >
                  <Text style={adminStyles.buttonText}>Delete Photos</Text>
                </TouchableOpacity>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  e.stopPropagation();
                  onPhotoUpload(venue.id, e.target.files[0]);
                }}
                style={{ display: 'none' }}
                id={`photo-upload-${venue.id}`}
              />
              <TouchableOpacity
                style={adminStyles.uploadButton}
                onPress={(e) => {
                  e.stopPropagation();
                  document.getElementById(`photo-upload-${venue.id}`).click();
                }}
              >
                <Text style={adminStyles.buttonText}>Upload Photo</Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      </ImageBackground>
    </TouchableOpacity>
  );
}; 